module.exports = __webpack_public_path__ + "assets/img/RM88.5fbf62b1.png";